export default {
  setGlossaryWikiNaturalIdState(state, naturalId) {
    state.naturalId = naturalId;
  },
  setGlossaryWikiDataState(state, {title, content, imgUrl, wikiUrl}) {
    state.data = {title, content, imgUrl, wikiUrl};
  },
};
